import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import { Form, Select, Row, Col, Card } from 'antd';

import { RichTextEditor } from '@seims/shared';

import { fieldValidity } from "../custom/eventEnum";

const Feedbacknotes = ({onStatusUpdate, formData, formRef}) => {

  const [feedBack, setFeedBack] = useState(true);
  const [feedBackNotes, setFeedBackNotes] = useState(true);
  const [value, setValue] = useState();
  const [ValidStatus, setValidStatus] = useState(fieldValidity.SUCCESS);
  const [ValidNotesStatus, setValidNotesStatus] = useState(fieldValidity.SUCCESS);
  const [ValidityMsg, setValidityMsg] = useState("");
  const [ValidityNotesMsg, setValidityNotesMsg] = useState("");
  const [disabled, setDisabled] = useState(false);

  const formName = "FeedbacknotesForm";
  const [form] = Form.useForm();

  const { key } = useParams();

  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  useEffect(() => {
    if (formRef != null) {
      formRef.current = form;
    }
  }, [form, formRef])
  


  const onSave = async () => {
    
    if (!form.getFieldValue('status')) {
      setValidityMsg("Review status is required");
      setValidStatus(fieldValidity.ERROR);
      return;
    }

    if (form.getFieldValue('status') === "Approve") {
      setValidityNotesMsg("");
      setValidNotesStatus(fieldValidity.SUCCESS);
    }
    else {
      if (!form.getFieldValue('notes')) {
        setValidityNotesMsg("Feedback notes is required");
        setValidNotesStatus(fieldValidity.ERROR);
        return;
      }
    }

    const id = key.substring(key.indexOf("x") + 1, key.length);
    const data = {
      eventId: id,
      action: form.getFieldValue('status'),
      notes: form.getFieldValue('notes'),
    };

    formRef?.current?.setFieldsValue({ status: data.action, notes: data.notes });

    // var statusUpdate = form.getFieldValue('status') === "Approve" ? "Approved" :
    //   form.getFieldValue('status') === "Reject" ? "Rejected" : "Send for revision";

      // const isSuccessful = await handleSave(data);
      // if (isSuccessful) {
      //     // onStatusUpdate(response.data.value)  
      //     setValidityMsg("");
      //     setValidityNotesMsg("");
      //     // hide();
      //     setDisabled(false);
      //     form.resetFields();
      // }
    // setDisabled(true);
    // try {
    //   const response = await service.updateEventStatus(data);
    //   if (response.status === 200 || response.status === 201) {
    //     msg = util.parseMessages(Messages.UPDATE_STATUS, "Event", statusUpdate);
    //     openNotification(action, msg, Notify.SUCCESS);
       
    //     onStatusUpdate(response.data.value)  
    //     setValidityMsg("");
    //     setValidityNotesMsg("");
    //     hide();
    //     setDisabled(false);
    //     return;
    //   }

    //   msg = util.parseMessages(Messages.UPDATE_FAILURE_STATUS, "Event", statusUpdate);
    //   openNotification(action, msg, Notify.ERROR);

    // } catch (error) {

    //   msg = util.parseMessages(Messages.UPDATE_FAILURE_STATUS, "Event", statusUpdate);
    //   openNotification(action, msg, Notify.ERROR);

    //   recordError(error)

    // }
  }

  const handleFeedbackChange = (value) => {
    setValue(value);
    form.setFieldsValue({ notes: value });
    setValidityNotesMsg("");
  }

  const onStatusChange = (value) => {
    console.log("onStatusChange", value);
    setFeedBack(true)
    if (value) {
      setValidStatus(fieldValidity.SUCCESS)
      setValidityMsg("")
    };

    if (value === "Approve") {
      setValidNotesStatus(fieldValidity.SUCCESS)
      setValidityNotesMsg("");
      setFeedBackNotes(false);

    }

    if (value === "Revise" || value === "Reject") {
      setValidNotesStatus(fieldValidity.SUCCESS)
      setValidityMsg("")
      setValidityNotesMsg("");
      setFeedBackNotes(true);
    }

  }
  const statuses = [
    // { label: 'Send for revision', value: 'Revise' },
    { label: 'Approved', value: 'Approve' },
    { label: 'Rejected', value: 'Reject' },
  ];


  return (
    <div>
      <Card size={"large"} title="Feedback Notes" bordered={true}>
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          layout="vertical"
          onFinish={onSave}
        >

          <Form.Item
            name="status"
            label="Review Status"
            validateStatus={ValidStatus}
            help={ValidityMsg}
            rules={[
              {
                required: feedBack,
                message: ValidityMsg,
              },
            ]}
          >
            <Select onChange={onStatusChange}
              placeholder="Please select review status"
              value={statuses.value}
              options={statuses}
            />
          </Form.Item>
          <Form.Item
            name="notes"
            label="Feedback Notes"

            validateStatus={ValidNotesStatus}
            help={ValidityNotesMsg}
            rules={[
              {
                required: feedBackNotes,
                message: ValidityNotesMsg,
              },
            ]}
          >
            <RichTextEditor placeholder={'Please add feedback notes here...'} supportMultiMedia={false} value={value} onChange={handleFeedbackChange} />
          </Form.Item>
        </Form>
        <Row>
        </Row>
        <Row>
          <Col xs={24} className="right-align">
            {/* <Button key="3a" type="primary" onClick={onSave} icon={<EditOutlined />} style={{ marginRight: 10 }} disabled={disabled}>Save</Button>&nbsp; */}
            {/* <Link key="1" to="/eventsmanagement"><Button type="default">Back</Button></Link> */}
          </Col>
        </Row>
      </Card>
      <br/>

    </div>
  )
}

export default Feedbacknotes